import { render } from "./bankAccount.vue?vue&type=template&id=122926c2&scoped=true"
import script from "./bankAccount.vue?vue&type=script&lang=js"
export * from "./bankAccount.vue?vue&type=script&lang=js"

import "./bankAccount.vue?vue&type=style&index=0&id=122926c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122926c2"]])

export default __exports__